import { render } from "./mutitabs.vue?vue&type=template&id=041e2f40"
import script from "./mutitabs.vue?vue&type=script&lang=js"
export * from "./mutitabs.vue?vue&type=script&lang=js"

import "./mutitabs.vue?vue&type=style&index=0&id=041e2f40&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__